import { TextSelectionSearchWrapper } from '@components/common/TextSelectionSearchPopover';
import ErrorBoundary from '@components/ErrorBoundary';
import PageContainer from '@components/PageContainer';
import { OverallAnalysis, OverallAnalysisNotFound } from '@components/common/OverallAnalysis';
import NoAnalysis from '@components/dynamic-survey/details/NoAnalysis';
import Spinner from '@components/spinner/Spinner';
import { useInterviewOverallAnalysis } from '@hooks/getQueries';
import { Box } from '@mui/material';
import { Suspense } from 'react';
import { useParams } from 'react-router-dom';

const OverallAnalysisContainer = () => {
  const { id } = useParams();
  const { data } = useInterviewOverallAnalysis({ interviewId: id });

  return (
    <Box sx={{ p: 2, pr: 4, my: 3, width: '90%', maxWidth: '800px', mx: 'auto' }}>
      <TextSelectionSearchWrapper>
        {data?.report ? (
          <>
            <OverallAnalysis data={data?.report} />
          </>
        ) : (
          <OverallAnalysisNotFound text="Interview" />
        )}
      </TextSelectionSearchWrapper>
    </Box>
  );
};

export default function InterviewOverallAnalysis() {
  const { id } = useParams();

  return (
    <PageContainer title={'Interview | Report'} description={'Interview'}>
      <Suspense fallback={<Spinner />}>
        <ErrorBoundary FallbackComponent={() => <NoAnalysis studyId={id} />}>
          <Suspense fallback={<Spinner />}>
            <OverallAnalysisContainer />
          </Suspense>
        </ErrorBoundary>
      </Suspense>
    </PageContainer>
  );
}
